module.exports = __webpack_public_path__ + "img/2_14.f72841c8.jpg";